/**
 * Header ticker component
 */

import EditableHeaderTickerBlock from "./EditableHeaderTickerBlock"

class HeaderTicker {

    /**
     * HeaderTicker component constructor
     * @param {HTMLElement} domElement
     */
    constructor(domElement = null) {
        this.container = $(domElement)
        this.isEditmode = this.container.hasClass('editmode')

        this.editableInstances = [];

        if (this.isEditmode) {
            this.createEditableInstances();

            this.setEditableEventListeners();
            return
        }

        const { name, index } = this.container.data()
        this.brickId = `${name}-brick_${index}`

        this.init()
        this.setEventListeners()
    }

    /**
     * Destructor method
     */
    destroy() {
        this.removeEventListeners();
        this.destroyEditableInstances();

        if (this.editModeObserver) {
            this.editModeObserver.disconnect();
            this.editModeObserver = null;
        }
    }

    /**
     * Attach event listeners
     */
    setEventListeners() {
        this.adjustHeight()

        // Close ticker action
        this.container.on('click touch', '.ticker-close-button', () => {
            this.container.addClass('d-none')
            this.removeEventListeners()
            this.saveToLocalStorage()

            // Remove custom css
            this.container.parents('body').find('main').first().css('margin-top', '')
        })

        // Bootstrap doesn't register keyboard controls until you manually press the button at least once for some reason
        $(document).on(`keydown.${this.brickId}`, event => {
            if (event.keyCode == 37) {
                this.container.find('.carousel-control-prev').trigger('click')
            }

            if (event.keyCode == 39) {
                this.container.find('.carousel-control-next').trigger('click')
            }
        })

        this.container.on('click touch', '.carousel-control-next, .carousel-control-prev', () => {
            if (this.container.hasClass('expanded')) {
                this.container.removeClass('expanded')
                this.container.find('.ticker-expand').removeClass('expanded')
            }
        })

        // Expand ticker text
        this.container.on('click touch', '.ticker-expand', (event) => {
            if (this.container.hasClass('expanded')) {
                this.container.removeClass('expanded')
                $(event.currentTarget).removeClass('expanded')
            } else {
                this.container.addClass('expanded')
                $(event.currentTarget).addClass('expanded')
            }
        })

        // Expand with click on visible text
        this.container.on('click touch', '.main-text-wrapper', event => {
            const textWrapper = $(event.currentTarget)
            const expandButton = textWrapper.next('.ticker-expand')

            // Can't be expanded
            if (expandButton.hasClass('d-none')) {
                return
            }

            this.container.addClass('expanded')
            expandButton.addClass('expanded')
        })

        $(window).on('resize', () => {
            this.adjustHeight()

            this.showExpandIcons()
        })
    }

    /**
     * Attach event listeners ONLY triggered in edit mode
     */
    setEditableEventListeners() {
        // MutationObserver to detect when new blocks are added
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                if (mutation.type === "childList") {
                    mutation.addedNodes.forEach(node => {
                        if ($(node).attr("data-real-name") === "headerTickerBlock") {
                            this.createEditableInstances();
                        }
                    });
                }
            });
        });


        // Start observing the container where blocks are added
        observer.observe(this.container[0], {
            childList: true,
            subtree: true,
        });

        this.editModeObserver = observer;
    }

    /**
     * Remove attached event listeners
     */
    removeEventListeners() {
        this.container.off('click touch')
        $(document).off(`keydown.${this.brickId}`)
    }

    init() {
        // Set max height as full screen
        const calculatedHeight = window.innerHeight
        this.container.css('maxHeight', `${calculatedHeight}px`)

        // Move it to top of the page
        this.container.removeClass('position-fixed top-0 start-0')
        $('header').prepend(this.container)

        this.checkLocalStorage()

        this.showExpandIcons()
    }


    /**
     * Create instances of EditableHeaderTickerBlock
     */
    createEditableInstances() {
        this.destroyEditableInstances();

        this.container.find(".header-ticker--editmode-container").each((i, tickerBlock) => {
            const instance = new EditableHeaderTickerBlock(tickerBlock);
            this.editableInstances.push(instance);
        });
    }

    /**
     * Destroy all existing instances of EditableHeaderTickerBlock
     */
    destroyEditableInstances() {
        this.editableInstances.forEach((instance) => {
            if (typeof instance.destroy === "function") {
                instance.destroy();
            }
        });
        this.editableInstances = [];
    }

    checkLocalStorage() {
        // Check if notifications were already removed
        const notifications = JSON.parse(localStorage.getItem('notifications')) ?? []

        const carouselItems = this.container.find('.carousel-item')
        carouselItems.each((_, item) => {
            const elements = $(item).find('.main-text-wrapper').children()
            elements.each((index, element) => {
                if (index == 0) {
                    $(element).addClass('first-element')
                } else {
                    $(element).addClass('d-none')
                }
            })

            // Handle any width icon
            const textContainer = $(item).find('.text-container-content')
            if (textContainer.hasClass('has-icon')) {
                const iconClone = textContainer.parent().find('.image-container').clone()
                // iconClone.css('display', 'block')
                iconClone.css('visibility','hidden')
                $('body').append(iconClone);
                const icon = iconClone.find('img, svg').eq(0).css({'height': '24px', 'width': 'auto'})
                const iconWidth = icon.outerWidth() + 10 // 10 is gap between icon and text
                iconClone.remove()
                textContainer.css('max-width', `calc( 100% - ${iconWidth}px )`)
            }
        })

        if (!notifications || !notifications.length) {
            this.container.removeClass('d-none')
            return
        }

        const newNotifications = []
        carouselItems.each((_, item) => {
            const { id } = $(item).data()
            const notification = item.innerHTML
            const foundNotification = notifications.find(el => el.id == id)
            if (!foundNotification || foundNotification.content != notification) {
                newNotifications.push(id)
            }
        })

        if (newNotifications.length) {
            this.container.removeClass('d-none')
            let setActive = false

            carouselItems.each((_, item) => {
                const { id } = $(item).data()

                if (!newNotifications.includes(id)) {
                    $(item).remove()
                } else {
                    // Set first notification that is new as active slide
                    if (!setActive) {
                        $(item).addClass('active')
                        setActive = true
                    }
                }
            })
        }
    }

    saveToLocalStorage() {
        const carouselItems = this.container.find('.carousel-item')
        const notifications = JSON.parse(localStorage.getItem('notifications')) ?? []
        carouselItems.each((_, item) => {
            const { id } = $(item).data()
            const notification = item.innerHTML
            notifications.push({
                id: id,
                content: notification
            })
        })
        localStorage.setItem('notifications', JSON.stringify(notifications))
    }

    showExpandIcons() {
        this.container.find(".carousel-item").each((i, item) => {
            const $item = $(item);
            const $firstElement = $item.find('.first-element');

            // Temporarily make the slide visible
            const wasHidden = !$item.hasClass('active');
            if (wasHidden) {
                $item.css({ position: 'absolute', visibility: 'hidden', display: 'block' });
            }

            // Check overflow
            if ($firstElement[0].scrollWidth > $firstElement[0].clientWidth) {
                $item.find('.ticker-expand').removeClass('d-none');

                $item.find('.text-container-content').addClass('has-overflow')
            } else {
                $item.find('.ticker-expand').addClass('d-none');

                $item.find('.text-container-content').removeClass('has-overflow')
            }

            // Restore original state if it was hidden
            if (wasHidden) {
                $item.css({ position: '', visibility: '', display: '' });
            }
        });
    }

    adjustHeight() {
        // Add custom css
        const header = this.container.parent('header')
        this.container.parents('body').find('main').first().css('margin-top', `${header.outerHeight()}px`)
    }
}

export default HeaderTicker
